import { render, staticRenderFns } from "./tabs-qualifications.vue?vue&type=template&id=291c322d&scoped=true&"
import script from "./tabs-qualifications.vue?vue&type=script&lang=js&"
export * from "./tabs-qualifications.vue?vue&type=script&lang=js&"
import style0 from "./tabs-qualifications.vue?vue&type=style&index=0&id=291c322d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291c322d",
  null
  
)

export default component.exports